import { footerInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200 py-14 md:py-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <a href="#hero" className="text-xl font-heading text-foreground-950 whitespace-nowrap">韩漫网</a>
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mt-4 max-w-xs">
              {footerInfo.intro}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-900 mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerInfo.quickLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-900 mb-4">{footerInfo.partners.title}</h4>
            <p className="text-xs text-foreground-500">更多合作伙伴即将入驻，敬请期待。</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 韩漫网 · 韩漫大全推荐平台 · 韩漫免费下拉式阅读
            </p>
            <p className="text-xs text-foreground-400">
              韩漫全集 · 韩漫完结 · 韩漫完整版 · 韩漫全本已完结
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}